import { delay, filter, map, retry, switchMap } from "rxjs/operators";
import { selectIsFortuneTellerEventRunning } from "../../../selectors/selectFortuneTellerEventInfo";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionEventInfo } from "../../info/event/actionEventInfo";
import { actionFortuneTellerEventReceived, TypeActionFortuneTellerEventInfo, } from "../actionFortuneTellerEventInfo";
export var epicFortuneTellerEventInfo = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionEventInfo.Received ||
            action.type === TypeActionEventInfo.StartEvent ||
            action.type === TypeActionFortuneTellerEventInfo.Request;
    }), delay(100), filter(function () {
        return selectIsFortuneTellerEventRunning(state$.value);
    }), switchMap(function () {
        var playerId = selectOwnPlayerId(state$.value);
        return deps
            .netSend({
            id: CommandCode.FortuneTellerInfo,
            props: {
                playerId: playerId,
            },
        })
            .pipe(map(actionFortuneTellerEventReceived), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/fortune-teller-event/epics/epicFortuneTellerEventInfo.ts
// module id = 1858
// module chunks = 3